module.exports = __webpack_public_path__ + "static/media/tool-making.b2e39479.jpg";